export const standardCategories = [
    {
        name: 'Appliances',
        id: 'appliances',
        subCategories: [
            {
                subCategoryId: 'applianceBundle',
                featured: true,
                isBundle: false,
                plans: [
                    {
                        planId: 'standardApplianceBundle',
                        title: 'Standard Appliance Bundle',
                        featured: true,
                        price: 25,
                        coverageLimit: 1000
                    },
                    {
                        planId: 'premiumApplianceBundle',
                        title: 'Premium Appliance Bundle',
                        featured: false,
                        price: 25,
                        coverageLimit: 1000
                    },
                    {
                        planId: 'bundleService',
                        title: 'Appliance Servicing',
                        featured: false,
                        price: 25,
                        coverageLimit: 1000
                    }
                ]
            },
            {
                subCategoryId: 'kitchen',
                featured: false,
                isBundle: false,
                plans: [
                    {
                        planId: 'kitchenAppliance',
                        title: 'Kitchen Appliance Coverage',
                        featured: false,
                        price: 25,
                        coverageLimit: 1000
                    },
                    {
                        planId: 'kitchenService',
                        title: 'Kitchen Appliance Service',
                        featured: false,
                        price: 25,
                        coverageLimit: 1000
                    }
                    // ...
                ]
            },
            {
                subCategoryId: 'laundry',
                featured: false,
                isBundle: false,
                plans: [
                    {
                        planId: 'laundryAppliance',
                        title: 'Laundry Appliance Bundle',
                        featured: false,
                        price: 25,
                        coverageLimit: 1000
                    },
                    {
                        planId: 'laundryService',
                        title: 'Laundry Appliance Service',
                        featured: false,
                        price: 25
                    }
                    // ...
                ]
            }
        ]
    },
    {
        name: 'Heat & Air',
        id: 'hvac',
        subCategories: [
            {
                subCategoryId: 'hvacBundle',
                subCategoryName: 'Heating & Cooling',
                featured: true,
                isBundle: false,
                plans: [
                    {
                        planId: 'standardHvacBundle',
                        title: 'Standard Heat & Air',
                        featured: true,
                        price: 25,
                        coverageLimit: 1000
                    },
                    {
                        planId: 'premiumHvacBundle',
                        title: 'Premium Heat & Air',
                        featured: false,
                        price: 25,
                        coverageLimit: 1000
                    },
                    {
                        planId: 'hvacBundleService',
                        title: 'Heat & Air Service',
                        featured: false,
                        price: 25,
                        coverageLimit: 1000
                    }
                    // ...
                ]
            },
            {
                subCategoryId: 'heatOnly',
                subCategoryName: 'Heating System',
                featured: false,
                isBundle: false,
                plans: [
                    {
                        planId: 'standardHeatSystem',
                        title: 'Standard Heat',
                        featured: false,
                        price: 25,
                        coverageLimit: 1000
                    }
                    // ...
                ]
            },
            {
                subCategoryId: 'coolingOnly',
                subCategoryName: 'Cooling System',
                featured: false,
                isBundle: false,
                plans: [
                    {
                        planId: 'standardAcSystem',
                        title: 'Standard Cooling',
                        featured: false,
                        price: 25,
                        coverageLimit: 1000
                    }
                    // ...
                ]
            }
        ]
    },
    {
        name: 'Electric',
        id: 'electrical',
        subCategories: [
            {
                subCategoryId: '1',
                featured: false,
                isBundle: false,
                plans: [
                    {
                        planId: '',
                        title: 'PLAN TITLE',
                        featured: false,
                        price: 25,
                        coverageLimit: 1000
                    }
                    // ...
                ]
            },
            {
                subCategoryId: '2',
                featured: false,
                isBundle: false,
                plans: [
                    {
                        planId: '',
                        title: 'PLAN TITLE',
                        featured: false,
                        price: 25,
                        coverageLimit: 1000
                    }
                    // ...
                ]
            }
        ]
    },
    {
        name: 'Utilities',
        id: 'utilities',
        subCategories: [
            {
                subCategoryId: '1',
                featured: false,
                isBundle: false,
                plans: [
                    {
                        planId: '',
                        title: 'PLAN TITLE',
                        featured: false,
                        price: 25,
                        coverageLimit: 1000
                    }
                    // ...
                ]
            },
            {
                subCategoryId: '2',
                featured: false,
                isBundle: false,
                plans: [
                    {
                        planId: '',
                        title: 'PLAN TITLE',
                        featured: false,
                        price: 25,
                        coverageLimit: 1000
                    }
                    // ...
                ]
            }
        ]
    },
    {
        name: 'Plumbing',
        id: 'plumbing',
        subCategories: [
            {
                subCategoryId: '1',
                featured: false,
                isBundle: false,
                plans: [
                    {
                        planId: '',
                        title: 'PLAN TITLE',
                        featured: false,
                        price: 25,
                        coverageLimit: 1000
                    }
                    // ...
                ]
            },
            {
                subCategoryId: '2',
                featured: false,
                isBundle: false,
                plans: [
                    {
                        planId: '',
                        title: 'PLAN TITLE',
                        featured: false,
                        price: 25,
                        coverageLimit: 1000
                    }
                    // ...
                ]
            }
        ]
    }
];

export const dummyCoOps = [
    { name: 'Chicken Co-Op', id: 'chickenCoOp' },
    { name: 'All Co-Oped Up', id: 'coOpedUp' }
];
